/**
 * HR help text for the Reports module.
 *
 * A saved report defines what is pulled; a schedule decides when it runs and who
 * receives it. Scheduled runs happen on the server in the background, so the
 * time zone and date-range preset are evaluated at run time, not now.
 */

const report = {
  name: "Name HR will see in the report list. Use something that says what the report answers.",
  title: "Heading printed at the top of the generated report.",
  report_type_id: "What kind of report this is. It decides the columns and filters available.",
  model_name: "The data this report is built from, such as employees or attendance.",
  class_name: "The built-in report being generated. It decides the columns and how the data is gathered.",
  schema_table_id: "Database table the raw report reads from. Only pick this if you know the data layout.",
  report_id: "The saved report this schedule will run.",
  group: "Groups this report with related ones in the report list.",
  multiple: "Allow more than one value to be selected for this filter.",
  required: "When ticked, the report cannot be generated until this filter is filled in.",
  enable: "Include this column or filter in the report.",
  file_type: "Format the report is produced in: PDF for reading, Excel or CSV for further working.",
  tenant_ids: "Which companies this report is copied to.",
  employment_ids: "Employees the report covers, or who receive it, depending on the screen.",
  date_range_preset: "Which period the report covers each time it runs, worked out fresh at run time. Payroll Month follows the payroll cut-off rather than the calendar month. Choose Custom to fix exact dates instead.",
  custom_date_range: "The exact dates covered, used when the preset is set to Custom.",
};

const schedule = {
  name: "Name for this schedule so HR can recognize it in the list.",
  status: "Only an active schedule runs. Setting it inactive stops future runs without deleting the schedule.",
  frequency: "How often the report runs. Daily, weekly, and monthly ask for a time below; Custom lets you write your own timing expression.",
  time_of_day: "Time the report runs, in the time zone selected below. Required for daily, weekly, and monthly schedules.",
  timezone: "Time zone the run time and the date range are worked out in. Pick the time zone of the people receiving the report.",
  day_of_week: "Which day the weekly report runs on.",
  day_of_month: "Which day of the month the report runs on. A value like 31 is skipped in shorter months.",
  custom_cron_expression: "Advanced timing expression for schedules that do not fit daily, weekly, or monthly. Ask IT if you are unsure of the format.",
  email_to: "Email addresses that receive the report. Every address must be valid or the schedule is rejected.",
  email_cc: "Email addresses copied on the report.",
  subject: "Subject line of the email the report is sent with.",
  body: "Message sent in the body of the email, above the attached report.",
  employment_ids: "Employees who receive the report by email, as an alternative to typing addresses.",
  report_id: "The saved report this schedule runs.",
  file_type: "Format the report is attached in: PDF for reading, Excel or CSV for further working.",
  date_range_preset: "Which period each run covers, worked out fresh at run time so the report always carries current data.",
  custom_date_range: "The exact dates covered by every run, used when the preset is set to Custom. Unlike the presets, these dates do not move forward as time passes.",
};

export const reportTooltips = { report, schedule };
export default reportTooltips;
